import React, { Component } from 'react';
import { withStyles, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

const styles = (theme) => ({
  dialogRoot: {
    '& .MuiBackdrop-root': {
      background: 'none',
    },
    [theme.breakpoints.up('md')]: {
      // marginTop: '6%',
      // marginLeft: '2.5%',
      // height: '75vh',
    },
  },
  noShowCheckGrid: {
    paddingBottom: theme.spacing(2),
  },
  checkboxLabel: {
    fontSize: '0.85rem',
  },
});

class Emergency extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { matches: window.matchMedia('(max-width:600px)').matches };
  }

  handleChange = (e) => {
    const { cookies } = this.props;

    if (e.target.checked) {
      let date = new Date();
      date.setDate(date.getDate() + 1);
      // console.log(date.toUTCString());
      cookies.set('main_dialog', e.target.checked, { path: '/', expires: date });
      this.props.onClose();
    }
  };

  render() {
    const { classes, open, onClose } = this.props;
    // console.log('긴급공지이벤트', this.props.noticePopup);
    return (
      <Dialog
        fullWidth={true}
        maxWidth={'xs'}
        open={open}
        onClose={onClose}
        onBackdropClick={onClose}
        classes={{
          root: classes.dialogRoot,
        }}
      >
        <DialogTitle>
          <Grid container item xs={12}>
            <Grid container item xs={false} md={1}></Grid>
            <Grid container item xs={11} md={10} alignItems="center" justify="center">
              {this.props.noticePopup.title}
            </Grid>
            <Grid container item xs={1} alignItems="flex-start">
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container justify="center" style={{ padding: '2vh 2vw' }}>
            <div dangerouslySetInnerHTML={{ __html: this.props.noticePopup.content }} />
          </Grid>
          <Grid container justify="center" className={classes.noShowCheckGrid}>
            <div>
              <FormControlLabel
                value="하루동안띄우지않기"
                control={<Checkbox color="primary" size="small" onChange={(e) => this.handleChange(e)} />}
                label="하루동안 띄우지 않기"
                labelPlacement="end"
                classes={{
                  label: classes.checkboxLabel,
                }}
              />
            </div>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

export default withCookies(withStyles(styles)(Emergency));
